export const poweredByLink = `${process.env.REACT_APP_MAIN_WEBSITE_URL}`;
